import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from '../../../components/loader/SpinnerLogo';
import useFetch from '../../../hooks/useFetch';
import { RootState } from '../../../redux/store';
import { menuRoutes } from "../../../router/menu";
import { OrderService } from "../../../services/order/orderService";
import { OrderApiResponse } from "../../../type/entities/order-type";

export default function OrderProfileLayout({ children, isLoading }: { children: React.ReactNode, isLoading?: boolean }) {

    const { selectedInfoTab } = useSelector((state: RootState) => state.orders);
    const { id = '' } = useParams<{ id: string }>();
    const navigate = useNavigate();

    const [data] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await (new OrderService()).getOrderById(id);
        return response.getResponseData() as OrderApiResponse;
    }, [id]));

    useEffect(() => {
        const targetTab = selectedInfoTab && selectedInfoTab.length > 0 ? selectedInfoTab : 'info';

        if (id && targetTab) {
            navigate(`${menuRoutes.orders.path}/${id}/profile/` + targetTab);
        }
    }, [selectedInfoTab, id, navigate]);

    // RENDER

    return (
        <div className="content h-full w-full min-w-0 p-2 pt-6">
            {isLoading && !data ? <Loader height='60vh' /> : children}
        </div>
    );
}
